(function() {
  'use strict';

  angular.module('app').factory('WorkflowService', WorkflowService);

  function WorkflowService(WebApiService) {
    return {
      getWFGroups: function(brandId, objectLevel) {
        var queryString = {
          BrandId: brandId,
          ObjectLevel: objectLevel
        };

        var options = {
          ignoreLoadingBar: true
        };

        return WebApiService.get('/api/Workflow/WFGroups', queryString, options);
      },

      getWFEventLogs: function(startDate, endDate, ignoreLoader) {
        var queryString = {
          StartDate: startDate,
          EndDate: endDate
        };

        var options = {
          ignoreLoadingBar: ignoreLoader
        };

        return WebApiService.get('/api/Workflow/WFEventLogs', queryString, options);
      },

      logDataChangedEvent: function(projLevel, projId) {
        var postBody = {
          projLevel: projLevel,
          projId: projId
        };

        return WebApiService.postJson('/api/Workflow/LogDataChangedEvent', postBody);
      }
    };
  }
})();
